import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { OtherDocuments } from '@/sections/termsAndConditions/OtherDocuments';
import HeroSimple from '@/sections/HeroSimple';
import { SeoHeader } from '@/components/SeoHeader';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(27);
  const {
    menuPromoBanners
  } = t0;
  usePageView("otherDocuments");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["otherDocuments", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <HeroSimple title={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative z-10 mx-auto flex max-w-[75rem] flex-col gap-6 px-4 pb-20 lg:pb-40"><OtherDocuments /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className="bg-blue-50">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isCsLanguage || $[17] !== t) {
    t10 = <div className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "otherDocumentsMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "otherDocumentsMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "otherDocumentsMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoPayInThree",
        title: t("core:link.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "otherDocumentsMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "otherDocumentsMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "otherDocumentsMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "otherDocumentsMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "otherDocumentsMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "otherDocumentsMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></div>;
    $[16] = isCsLanguage;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <div className="relative overflow-hidden bg-blue-100">{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== menuPromoBanners || $[23] !== t12 || $[24] !== t4 || $[25] !== t8) {
    t13 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t8}{t9}{t12}</Layout>;
    $[22] = menuPromoBanners;
    $[23] = t12;
    $[24] = t4;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'otherDocuments']))
  }
});